module.exports = "/_next/static/images/4831c6923e9d5a299931d121f6ff9701-young-people-walking@2x.jpg";